import { useEffect, useState } from "react";
import {
  fetchApprovalData,
  sendApprovalRequest,
  sendPayRequest,
  sendRejectRequest,
} from "../Api/ExpenseApproval";
import { Container, Table, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";
import { useAuth } from "../Context/AuthContext";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { FaChevronDown, FaCheck, FaTimes, FaMoneyBillWave  } from "react-icons/fa";

const ExpenseApproval = () => {
  const [approvals, setApprovals] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [paidFilter, setPaidFilter] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const { user } = useAuth();
  const handleDownloadExcel = () => {
    const formattedData = filteredApprovals.map((approval, index) => ({
      "S.No": index + 1,
      "Expense Type": approval?.expenses?.expenseType,
      "Employee Name": approval?.user?.name,
      "Employee ID": approval?.user?.resourceId,
      Merchant: approval?.expenses?.merchantName,
      Date: new Date(approval?.expenses?.dateofExpense).toLocaleDateString(),
      Amount: approval?.expenses?.amountSpent,
      Currency: approval?.expenses?.currency,
      "Payment Method": approval?.expenses?.paymentMethod,
      Description: approval?.expenses?.descriptionNotes,
      Project: `${approval?.project} - ${approval?.expenses?.projectId}`,
      Status:
        approval?.expenses?.approvalStatus === "W" ? "Waiting" : "Approved",
      "Paid Status": approval?.expenses?.paidStatus ? "Paid" : "Not Paid",
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Expenses");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const file = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(file, "Expense_Approval.xlsx");
  };
  useEffect(() => {
    const loadApprovals = async () => {
      try {
        const data = await fetchApprovalData(user?.organisationId);
        setApprovals(data.data || []);
      } catch (error) {
        toast.error("🦄 Error Fetching Approval Data");
      }
    };
    loadApprovals();
  }, []);

  const handleApprove = async (expenseId) => {
    try {
      await sendApprovalRequest(expenseId);
      toast.success(`🟢 Expense ${expenseId} Approved!`);
      setTimeout(() => window.location.reload(), 1000);
    } catch (error) {
      toast.error("❌ Error Sending Approval Request");
    }
  };

  const handlePay = async (expenseId) => {
    try {
      await sendPayRequest(expenseId);
      toast.success(`🟢 Paid Expense ${expenseId} `);
      setTimeout(() => window.location.reload(), 1000);
    } catch (error) {
      toast.error("❌ Error Sending Approval Request");
    }
  };

  const handleReject = async (expenseId) => {
    try {
      await sendRejectRequest(expenseId);

      toast.success(`🔴 Expense ${expenseId} Rejected!`);

      setTimeout(() => window.location.reload(), 1000);
    } catch (error) {
      toast.error("❌ Error Rejecting Expense");
    }
  };

  const filteredApprovals = approvals.filter((approval) => {
    const expense = approval?.expenses;

    const searchText = `
    ${approval?.user?.name || ""}
    ${approval?.user?.resourceId || ""}
    ${expense?.merchantName || ""}
    ${expense?.expenseType || ""}
    ${expense?.descriptionNotes || ""}
    ${approval?.project || ""}
    ${expense?.projectId || ""}
  `.toLowerCase();

    const matchesSearch =
      searchTerm === "" || searchText.includes(searchTerm.toLowerCase());

    const matchesStatus =
      statusFilter === "" || expense?.approvalStatus === statusFilter;

    const matchesPaid =
      paidFilter === "" || String(expense?.paidStatus) === paidFilter;

    const expenseDate = moment(expense?.dateofExpense);

    const matchesFrom = !fromDate || expenseDate.isSameOrAfter(fromDate, "day");

    const matchesTo = !toDate || expenseDate.isSameOrBefore(toDate, "day");

    return (
      matchesSearch && matchesStatus && matchesPaid && matchesFrom && matchesTo
    );
  });

  return (
    <div className="main-content expand">
      <Container fluid className="list-container">
        <span className="list-title">Expense Approval</span>
        <div
          style={{
            display: "flex",
            gap: "10px",
            flexWrap: "wrap",
            margin: "15px 0",
          }}
        >
          <input
            type="text"
            placeholder="Search employee, merchant, project..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="form-control"
            style={{ maxWidth: "250px" }}
          />

          <div style={{ position: "relative", maxWidth: "180px" }}>
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className="form-control"
              style={{
                appearance: "none",
                WebkitAppearance: "none",
                MozAppearance: "none",
                paddingRight: "35px",
              }}
            >
              <option value="">All Status</option>
              <option value="W">Waiting</option>
              <option value="A">Approved</option>
              <option value="R">Rejected</option>
            </select>

            <FaChevronDown
              style={{
                position: "absolute",
                right: "12px",
                top: "50%",
                transform: "translateY(-50%)",
                pointerEvents: "none",
                color: "#666",
                fontSize: "12px",
              }}
            />
          </div>

          <div style={{ position: "relative", maxWidth: "180px" }}>
            <select
              value={paidFilter}
              onChange={(e) => setPaidFilter(e.target.value)}
              className="form-control"
              style={{
                appearance: "none",
                WebkitAppearance: "none",
                MozAppearance: "none",
                paddingRight: "35px",
              }}
            >
              <option value="">All Payment Status</option>
              <option value="true">Paid</option>
              <option value="false">Not Paid</option>
            </select>

            <FaChevronDown
              style={{
                position: "absolute",
                right: "12px",
                top: "50%",
                transform: "translateY(-50%)",
                pointerEvents: "none",
                color: "#666",
                fontSize: "12px",
              }}
            />
          </div>

          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            className="form-control"
            style={{ maxWidth: "180px" }}
          />

          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            className="form-control"
            style={{ maxWidth: "180px" }}
          />

          <Button
            variant="secondary"
            onClick={() => {
              setSearchTerm("");
              setStatusFilter("");
              setPaidFilter("");
              setFromDate("");
              setToDate("");
            }}
          >
            Clear Filters
          </Button>

          <Button
            variant="success"
            onClick={handleDownloadExcel}
            style={{ marginBottom: "10px" }}
          >
            Download Excel
          </Button>
        </div>

        {filteredApprovals.length > 0 ? (
          <div className="table-wrapper">
            <div className="table-scroll-container">
              <Table bordered hover className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Expense Type</th>
                    <th>Employee Name</th>
                    <th>Employee ID</th>
                    <th>Merchant</th>
                    <th>Date</th>
                    <th>Amount</th>
                    <th>Currency</th>
                    <th>Payment Method</th>
                    <th>Description</th>
                    <th>Project Id</th>
                    <th>Status</th>
                    <th>Paid Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredApprovals.map((approval, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{approval?.expenses?.expenseType}</td>
                      <td>{approval?.user?.name}</td>
                      <td>{approval?.user?.resourceId}</td>
                      <td>{approval?.expenses?.merchantName}</td>
                      <td>
                        {new Date(
                          approval?.expenses?.dateofExpense,
                        ).toLocaleDateString()}
                      </td>
                      <td>{approval?.expenses?.amountSpent}</td>
                      <td>{approval?.expenses?.currency}</td>
                      <td>{approval?.expenses?.paymentMethod}</td>
                      <td>{approval?.expenses?.descriptionNotes}</td>
                      <td>
                        {" "}
                        {approval?.project} - {approval?.expenses?.projectId}
                      </td>
                      <td
                        className={
                          approval?.expenses?.approvalStatus === "W"
                            ? "status-waiting"
                            : "status-approved"
                        }
                      >
                        {approval?.expenses?.approvalStatus === "W"
                          ? "Waiting"
                          : approval?.expenses?.approvalStatus === "A"
                            ? "Approved"
                            : approval?.expenses?.approvalStatus === "R"
                              ? "Rejected"
                              : "-"}
                      </td>
                      <td>
                        {approval?.expenses?.paidStatus === true
                          ? "Paid"
                          : "Not Paid"}
                      </td>
<td>
  {approval?.expenses?.approvalStatus === "W" && (
    <div
      style={{
        display: "flex",
        gap: "6px",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Button
        size="sm"
        style={{
          background: "#28a745",
          border: "1px solid #28a745",
          color: "#fff",
          borderRadius: "6px",
          padding: "5px 12px",
          fontSize: "13px",
          fontWeight: "500",
          minWidth: "90px",
        }}
        onClick={() =>
          handleApprove(approval?.expenses?.expenseId)
        }
      >
        <FaCheck style={{ marginRight: "5px" }} />
        Approve
      </Button>

      <Button
        size="sm"
        style={{
          background: "#dc3545",
          border: "1px solid #dc3545",
          color: "#fff",
          borderRadius: "6px",
          padding: "5px 12px",
          fontSize: "13px",
          fontWeight: "500",
          minWidth: "90px",
        }}
        onClick={() =>
          handleReject(approval?.expenses?.expenseId)
        }
      >
        <FaTimes style={{ marginRight: "5px" }} />
        Reject
      </Button>
    </div>
  )}

  {approval?.expenses?.approvalStatus === "A" &&
    approval?.expenses?.paidStatus === false && (
      <Button
        size="sm"
        style={{
          background: "#0d6efd",
          border: "1px solid #0d6efd",
          color: "#fff",
          borderRadius: "6px",
          padding: "5px 12px",
          fontSize: "13px",
          fontWeight: "500",
          minWidth: "90px",
        }}
        onClick={() =>
          handlePay(approval?.expenses?.expenseId)
        }
      >
        <FaMoneyBillWave style={{ marginRight: "5px" }} />
        Pay
      </Button>
  )}
</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        ) : (
          <p className="no-data">No approval requests found.</p>
        )}
      </Container>
    </div>
  );
};

export default ExpenseApproval;
